const AnalyticsIcon = ({ color }: any) => {
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.75 2.75V19.25H19.25'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.142 7.33398L12.467 12.1007L9.90033 9.62565L6.41699 13.109'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default AnalyticsIcon
